/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableDataCellComponent } from './table-data-cell.component';

@NgModule({
  imports: [CommonModule],
  declarations: [TableDataCellComponent],
})
export class TableDataCellModule {}
